import React, {useEffect, useRef, useState} from "react"
import Select from "react-select"
import makeAnimated from "react-select/animated"

const animatedComponents = makeAnimated();

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

const SearchSelect = (props) => {
  const [loading, setLoading] = useState(false);
  const selectInputRef = useRef();

  useEffect(() => {
      const api = selectInputRef.current;

      if (!api) {
          return;
      }

      const hasValue = !!props?.state?.[props?.optionValue];

      if (!hasValue) {
          api.clearValue();
      }
      else {
          const current = api.getValue?.() ?? [];

          if (current.length) {
              api.setValue(current[0], 'set-value');
          }
      }}, [props?.state?.[props?.optionValue]]
  );

  const customFilterOption = (option, rawInput) => {
      return option
  };
  const debounceInputChange = debounce((inputValue) =>
    inputValue.length > 2
    ? (setLoading(true), props.onChange(inputValue))
    : (setLoading(false)),
    500);

  return (
    <Select
      name={props.name}
      ref={selectInputRef}
      options={props.options||[]}
      onInputChange={(inputValue) => debounceInputChange(inputValue)}
      onChange={(e) => {
        setLoading(false);
        e ? props.setState(e) : props.setState({ [props.optionValue]: '' })
      }}
      isDisabled={props.isDisabled}
      isLoading={loading}
      getOptionValue={(e) => e[props.optionValue]}
      getOptionLabel={(e) => e[props.optionText]}
      placeholder={props.placeholder}
      defaultValue={props.defaultValue}
      loadingMessage={() => null}
      noOptionsMessage={() => null}
      isClearable={(props.name === 'parcelPickup' || props.name === 'parcelDelivery') ? false : true}
      isSearchable
      components={animatedComponents}
      filterOption={customFilterOption}
      styles={{ control: styles => ({ ...styles, 
        borderColor: props.highlightRequired ? "red" : "#ccc" }), }}
    />
  )
}

export default SearchSelect;
